import { render, staticRenderFns } from "./DevPicker.vue?vue&type=template&id=6707ce12&"
import script from "./DevPicker.vue?vue&type=script&lang=js&"
export * from "./DevPicker.vue?vue&type=script&lang=js&"
import style0 from "./DevPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DevPicker.vue"
export default component.exports